export const authActionTypes = {
    signUp: 'signUp',
    logIn: 'logIn',
};
